// iOS PWA 토큰 유지를 위한 특화 유틸리티
import { getToken, saveToken } from './auth';
import { isRunningAsInstalledPwa } from '../services/pwaInstallService';

// iOS Safari에서 PWA인지 확인
export const isIOSPWA = () => {
  return isRunningAsInstalledPwa();
};

// iOS Safari에서 PWA 모드인지 확인
export const isStandaloneMode = () => {
  return window.navigator.standalone === true;
};

// 디바이스가 iOS인지 확인
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

// iOS PWA에서 토큰 지속성을 위한 주기적 저장
export const setupTokenPersistence = (token) => {
  if (isIOSPWA() && token) {
    // iOS PWA에서는 더 자주 토큰을 저장
    const saveTokenToAllStorages = () => {
      try {
        saveToken(token);
        console.log('iOS PWA 토큰 지속성 저장 완료');
      } catch (error) {
        console.error('토큰 저장 오류:', error);
      }
    };

    // 초기 저장
    saveTokenToAllStorages();
    
    // 30초마다 토큰 저장 (iOS PWA 메모리 정리 대응)
    const interval = setInterval(saveTokenToAllStorages, 30000);
    
    // 페이지 언로드 시 정리
    window.addEventListener('beforeunload', () => {
      clearInterval(interval);
    });
    
    return () => clearInterval(interval);
  }
};

// iOS PWA에서 앱이 백그라운드에서 포그라운드로 돌아올 때 토큰 복구
export const setupTokenRecovery = (onTokenRecovered) => {
  if (isIOSPWA()) {
    const handleAppResume = () => {
      console.log('iOS PWA 앱 재시작 감지');

      const token = getToken();

      if (token && onTokenRecovered) {
        saveToken(token);
        console.log('iOS PWA에서 토큰 복구됨');
        onTokenRecovered(token);
      }
    };

    // 여러 이벤트에 대응
    window.addEventListener('pageshow', handleAppResume);
    window.addEventListener('focus', handleAppResume);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        handleAppResume();
      }
    });

    return () => {
      window.removeEventListener('pageshow', handleAppResume);
      window.removeEventListener('focus', handleAppResume);
      document.removeEventListener('visibilitychange', handleAppResume);
    };
  }
  
  return () => {};
};

// iOS PWA에서 네트워크 상태 모니터링
export const setupNetworkMonitoring = (onNetworkChange) => {
  if (isIOSPWA()) {
    const handleOnline = () => {
      console.log('iOS PWA 네트워크 연결 복구');
      if (onNetworkChange) {
        onNetworkChange('online');
      }
    };

    const handleOffline = () => {
      console.log('iOS PWA 네트워크 연결 끊김');
      if (onNetworkChange) {
        onNetworkChange('offline');
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }
  
  return () => {};
};

// iOS PWA에서 메모리 부족 상황 감지
export const setupMemoryMonitoring = () => {
  if (isIOSPWA()) {
    // 메모리 사용량 모니터링 (가능한 경우)
    if ('memory' in performance) {
      const checkMemory = () => {
        const memory = performance.memory;
        const usedMB = memory.usedJSHeapSize / 1024 / 1024;
        const totalMB = memory.totalJSHeapSize / 1024 / 1024;
        
        // 메모리 사용량이 80%를 넘으면 경고
        if (usedMB / totalMB > 0.8) {
          console.warn('iOS PWA 메모리 사용량 높음:', `${usedMB.toFixed(1)}MB / ${totalMB.toFixed(1)}MB`);
        }
      };

      const interval = setInterval(checkMemory, 30000); // 30초마다 체크
      
      return () => clearInterval(interval);
    }
  }
  
  return () => {};
};
